<template>
  <div>
    <swiper
      :slidesPerView="4"
      :spaceBetween="12"
      :breakpoints="{
        320: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
        1700: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
      }"
      :centeredSlides="false"
      :modules="modules"
      class="mySwiper pb-2 pl-2"
    >
      <swiper-slide
        v-for="(element, index) in elements"
        :key="index"
        style="max-width: 194px"
      >
        <div
          :class="
            (category == 1 && element.company_id !== null) ||
            (category == 3 && element.company !== null)
              ? 'bg-light border border-2 border-danger rounded card '
              : ''
          "
        >
          <div
            class="card p-2"
            :style="'height:' + heightCard + 'px;max-width:194px'"
          >
            <div v-if="category == 1 || category == 3">
              <span
                class="product-label label-sale bg-primary"
                v-if="element.new"
                >Novita</span
              >
            </div>

            <a
              href="#"
              @click="getRedirectUrl(category, element.slug)"
              style="height: 141px"
            >
              <div v-if="element?.cover?.path != null">
                <div v-if="element?.cover?.type_file == 'pdf'">
                  <iframe
                    class="embed-responsive-item"
                    :src="element?.cover?.path"
                    width="100%"
                  ></iframe>
                </div>
                <div
                  v-if="
                    element?.cover?.type_file == 'jpg' ||
                    element?.cover?.type_file == 'png' ||
                    element?.cover?.type_file == 'jpeg'
                  "
                >
                  <img :src="element?.cover?.path" alt="Copertina biblioteca" />
                </div>

                <div
                  v-if="
                    element?.cover?.type_file == 'm4v' ||
                    element?.cover?.type_file == 'mp4'
                  "
                >
                  <video-component
                    :options="getOptions(element?.cover?.path)"
                  ></video-component>
                </div>
              </div>
              <div v-else class="pr-2">
                <img
                  :src="elementDefault"
                  alt="copertina post"
                  style="height: 138px"
                />
              </div>
            </a>

            <!-- End .product-media -->

            <div class="card-body bg-white">
              <div class="product-cat bg-white">
                <a href="#" @click="getRedirectUrl(category, element.slug)">
                  <i class="las la-bullhorn" style="font-size: 15px"></i> &nbsp;
                  <span v-if="category == 1 || category == 2">
                    {{ element.full_name }}
                  </span>
                  <span v-else>
                    {{ element.author }}
                  </span>
                </a>
              </div>
              <!-- End .product-cat -->
              <h3 class="product-title">
                <a href="#" @click="getRedirectUrl(category, element.slug)">
                  {{ element.name }}</a
                >
                <p v-if="element.company" class="text-danger">
                  Azienda promotrice: &nbsp;
                  <strong>{{ element.company }}</strong>
                </p>
                <br />
              </h3>
              <p v-if="category == 1" class="col-12 text-truncate">
                {{ element.description }}
              </p>
              <p
                v-if="category == 3"
                class="text-muted"
                style="font-size: 14px"
              >
                <span
                  class="'small badge rounded-pill badge-info p-2 border'"
                  style="font-size: 14px"
                >
                  <i class="las la-clock"></i> </span
                >&nbsp; {{ element.datetime_start }}
              </p>
              <p v-if="category == 3" style="font-size: 14px">
                <span
                  class="'small badge rounded-pill badge-info p-2 border'"
                  style="font-size: 12px"
                >
                  <i class="las la-clock"></i> </span
                >&nbsp; {{ element.datetime_end }}
              </p>
            </div>
          </div>
          <!-- End .product-body -->
        </div>
        <!-- End .product -->
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import router from "@/router";
//import VideoComponent from "@/components/VideoComponent.vue";
// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper";
import VideoComponent from "./VideoComponent.vue";

export default {
  name: "SwiperComponents",
  props: ["elements", "category"],
  components: {
    Swiper,
    SwiperSlide,
    VideoComponent,
    //VideoComponent,
  },
  setup() {
    return {
      modules: [Pagination],
    };
  },
  data() {
    return {
      heightCard: 300,
      elementDefault: "",
      swiperOption: {
        slidesPerView: 6, // Numero di elementi da visualizzare nella stessa riga
        spaceBetween: 5, // Spazio tra gli elementi
      },
    };
  },
  mounted() {},
  created() {
    if (this.category == 3) {
      this.heightCard = 369;
    }
    switch (parseInt(this.category)) {
      case 1:
      case 3:
        this.elementDefault =
          "https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/immagine_default.jpg";
        break;
      case 2:
        this.elementDefault =
          "https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/scrivi.jpg";
        break;
      case 4:
        this.elementDefault =
          "https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/scrivi.jpg";
        break;
    }
  },
  methods: {
    getOptions(path) {
      return {
        controls: true,
        autoplay: false,
        fluid: true,
        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
    getRedirectUrl(category, slug) {
      var url = "";

      switch (parseInt(category)) {
        case 1:
          url = "/casi-clinici/show/" + slug;

          router.push(url);
          break;
        case 2:
          url = "/library/show/" + slug;
          router.push(url);
          break;
        case 3:
          httpauth
            .get("/meetings/check-meeting/" + slug)
            .then((response) => {
              if (response.data.status == 1) {
                if (
                  response.data.data.status == "programming" ||
                  response.data.data.status == "progress"
                ) {
                  url = "/meeting/show/" + slug;
                } else if (response.data.data.status == "publish") {
                  url = "/meeting/registration/" + slug;
                }
                router.push(url);
              }
            })
            .catch((error) => {
              if (
                error.response.status == 401 &&
                error.response.data.message == "Unauthenticated."
              ) {
                const auth = useAuth();
                auth.clearToken();
                url = "/";
              }
            });
          router.push(url);
          break;

        case 4:
          url = "/presentation/show/" + slug;
          router.push(url);
          break;
        case 5:
          url = "/forum/" + slug;
          router.push(url);
          break;
      }
    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    changeSlide(index) {
      this.swiper.slideTo(index);
    },
  },
};
</script>

<style>
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide element {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
<style scoped>
.border-2 {
  border: 3.5px solid red !important;
}
.element-thumbnail {
  max-height: 136px;
}
</style>